import { Box, Divider, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { InviteCardProps } from "../types";
import { useSnapshot } from "valtio";
import { editorState } from "../../../../utils/editor";

const RsvpReminderSample: React.FC<InviteCardProps> = ({
  w,
  h,
  px,
  helloText,
  btnBg,
  btnSize,
  btnW,
  border,
}) => {
  const { mainContent, groomFirstName, brideFirstName } =
    useSnapshot(editorState);
  return (
    <Flex
      flexDir={"column"}
      bg={"#fff"}
      py={"9.8px"}
      px={px ?? "24px"}
      border={border ?? "1px solid #00000033"}
      w={w ?? "full" }
      h={h ?? "full" }
      maxW={"398px"}
      maxH={"600px"}
      minH={"450px"}
      alignItems={"center"}
    >
      <Box
        bg={"#f9f9f9"}
        borderRadius={"18.59px"}
        fontFamily={"font4"}
        py={"7.5px"}
        px={"14.7px"}
        mb={"5px"}
      >
        <Text fontSize={"9.96px"} textTransform={"uppercase"}>
          {mainContent.hashtag}❤️
        </Text>
      </Box>
      <Divider bg={"#00000030"} orientation="horizontal" />

      <Image
        src={"/images/ring-yellow.png"}
        // src={mainContent.coupleImage}
        borderRadius={"16px"}
        h={"100px"}
        w={"100%"}
        objectFit={"cover"}
        mt={"10px"}
      />
      <Text
        fontFamily={"font4"}
        fontSize={"12px"}
        // textTransform={"uppercase"}
        textAlign={"center"}
        py={"17px"}
      >
        Our big day is almost here, and we’re so excited to have you join us! If
        you haven’t already, please take a moment to RSVP so we can make sure
        everything is perfect for you.
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={"12.96px"}
        textAlign={"center"}
        pb={"17px"}
      >
        Looking forward to your reply and seeing you soon!
      </Text>

      <Text
        fontFamily={"font4"}
        fontSize={"15px"}
        textAlign={"center"}
        w={"100%"}
        pb={"17px"}
        fontWeight={600}
      >
        {groomFirstName} & {brideFirstName}
      </Text>
      <Flex
        bg={btnBg ?? "#000"}
        borderRadius={"29.41px"}
        w={btnW ?? "195.2px"}
        py={"11px"}
        justifyContent={"center"}
        alignItems={"center"}
        fontSize={btnSize ?? "0.765rem"}
        fontFamily={"font4"}
        textTransform={"uppercase"}
        letterSpacing={"1px"}
        fontWeight={600}
        color={"#fff"}
      >
        RSVP NOW
      </Flex>
    </Flex>
  );
};
export default RsvpReminderSample;
